import React, { forwardRef } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { appConfig } from '../../apiConfig';
import { useLanguage } from "../../context/LanguageProvider";

const DeliveryTicket = forwardRef(({ orders }, ref) => {
  const { t } = useLanguage();
  if (!orders || orders.length === 0) return null;
  console.log(orders);
  

  return (
    <div ref={ref} className="bg-white p-2">
      {orders.map((order, index) => (
        <div 
          key={order.id} 
          className={`w-[9cm] h-[9cm] border-2 border-black mx-auto mb-0 flex flex-col overflow-hidden text-black font-sans ${
            index !== orders.length - 1 ? 'page-break-after' : ''
          }`}
          style={{ pageBreakAfter: 'always' }}
        >
          {/* Header */}
          <div className="flex justify-between items-start p-2 border-b-2 border-black">
            <div className="w-1.5/3">
              <img 
                src={`/images/${appConfig.slug}-logo.png`} 
                alt={appConfig.name} 
                className="w-full h-auto object-contain max-h-[0.8cm]" 
              />
              <p className="text-[10px] mt-1 leading-tight font-medium">{t('print.delivery_ticket.boutique', { store: order.seller_info?.name_store || appConfig.name })}</p>
            </div>
            <div className="text-right flex flex-col justify-center h-full">
              <h1 className="text-xl font-bold leading-tight">{t('print.delivery_ticket.hub')}</h1>
              <h1 className="text-xl font-bold leading-tight uppercase">{order.client?.city}</h1>
            </div>
          </div>

          {/* Contact Line */}
          <div className="p-1 text-[9px] border-b-2 border-black font-bold text-center uppercase tracking-wide">
            {t('print.delivery_ticket.contact_info', { name: appConfig.name, phone: '0663610738' })}
          </div>

          {/* Order & Client Info Section */}
          <div className="flex border-b-2 border-black flex-1 min-h-0">
            <div className="w-2/3 p-2 border-r-2 border-black flex flex-col justify-between">
              <div className="space-y-0.5">
                  <p className="text-[11px] font-bold border-b border-gray-200 pb-0.5">{order.code}</p>
                  <div className="flex justify-between items-center gap-2">
                    <div className="space-y-0.5" >
                      <h2 className="text-[12px] font-bold uppercase">{order.client?.name}</h2>
                      <p className="text-[11px] font-bold">
                        {/* {
                            order.client?.phone
                            ? order.client.phone.length == 9 && order.client.phone.startsWith("6")
                            ? "0" + order.client.phone
                            : order.client.phone
                            : ""
                        } */}
                        {
                          order.client?.phone
                            ? String(order.client.phone).length === 9 &&
                              String(order.client.phone).startsWith("6")
                              ? "0" + order.client.phone
                              : order.client.phone
                            : ""
                        }
                      </p>
                    </div>
                    <div className="space-y-0.5" >
                      <p className="text-[10px] font-bold uppercase">{order.client?.city}</p>
                      <p className="text-[10px] leading-tight">{order.client?.address}</p>
                    </div>
                  </div>
              </div>
              
              <div className="mt-1">
                <p className="text-[8px] italic text-gray-600">{t('print.delivery_ticket.send_date', { date: new Date().toLocaleDateString('fr-FR') })}</p>
                <div className="flex gap-3 items-center mt-1 border-t border-gray-200 pt-1">
                  <div className="flex items-center gap-1">
                    <div className="w-3.5 h-3.5 border border-black flex items-center justify-center text-[9px] font-bold">✓</div>
                    <span className="text-[7px] font-bold">{t('print.delivery_ticket.open')}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <div className="w-3.5 h-3.5 border border-black"></div>
                    <span className="text-[7px] font-bold">{t('print.delivery_ticket.change')}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column: QR Code */}
            <div className="w-1/3 flex items-center justify-center bg-white">
              <div className="border border-gray-200 p-1 rounded">
                <QRCodeSVG 
                  value={order.code || order.id?.toString()} 
                  size={75}
                  level="H"
                  includeMargin={false}
                />
              </div>
            </div>
          </div>

          {/* Products & Price Section */}
          <div className="flex h-1/3 border-b-2 border-black overflow-hidden">
            <div className="w-2/3 border-r-2 border-black flex flex-col">
              <div className="flex-1 overflow-hidden">
                <table className="w-full text-[9px] border-collapse">
                  <thead>
                    <tr className="bg-gray-50 border-b border-black">
                      <th className="text-left px-1 border-r border-black font-bold uppercase py-0.5">{t('print.delivery_ticket.product_header')}</th>
                      <th className="px-1 w-8 font-bold uppercase py-0.5">{t('print.delivery_ticket.qty_header')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {order.products?.map((prod, idx) => {
                      const allVariants =
                        prod.variants?.flatMap(v =>
                          v.values?.map(val => val.name || val)
                        ) || [];

                      return (
                        <tr key={idx} className="border-b border-gray-200 last:border-0">
                          <td className="px-1 py-0.5 leading-tight truncate font-medium">
                            {prod.name}
                            {allVariants.length > 0 && (
                              <span className="text-[10px] text-gray-600 font-normal">
                                {" "}({allVariants.join(", ")})
                              </span>
                            )}
                          </td>

                          <td className="px-1 py-0.5 text-center font-bold">
                            {prod.quantity}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <div className="border-t border-black py-1 text-center">
                <p className="text-[15px] font-black tracking-tighter">{t('print.delivery_ticket.total', { total: order.total })}</p>
              </div>
            </div>
            
            {/* ID Intern & Commentaire */}
            <div className="w-1/3 p-1 flex flex-col text-[8px] gap-1">
              <div className="border-b border-gray-200 pb-0.5">
                <p className="font-bold uppercase text-[7px] text-gray-500">{t('print.delivery_ticket.id_internal')}</p>
                <p className="font-bold truncate">{order.id}</p>
              </div>
              <div className="flex-1 overflow-hidden">
                <p className="font-bold uppercase text-[7px] text-gray-500">{t('print.delivery_ticket.comment')}</p>
                <p className="leading-tight overflow-hidden text-ellipsis line-clamp-4 font-medium italic italic-color-gray-700">
                  {order.commentaire || ""}
                </p>
              </div>
            </div>
          </div>
        </div>
      ))}
      <style dangerouslySetInnerHTML={{ __html: `
        @media print {
          .page-break-after {
            page-break-after: always;
          }
          body { -webkit-print-color-adjust: exact; }
        }
      `}} />
    </div>
  );
});

DeliveryTicket.displayName = 'DeliveryTicket';

export default DeliveryTicket;
